import {
    Component,
    Input,
    Output,
    EventEmitter,
    ContentChild,
    TemplateRef,
    HostListener
} from '@angular/core';

@Component({
    selector: 'card-dropdown',
    template: `
        <span class="pi-card_dropdown_title">
            {{ title }}
        </span>
        <div
            class="pi-card_dropdownContent"
            [ngClass]="{
                'pi-card_dropdownContent--show': hovered
            }"
        >
            @for (item of items; track item; let i = $index) {
                <li
                    class="pi-card_dropdownContent_item"
                    (mousedown)="onItemClicked(i)"
                >
                    <ng-template
                        [ngTemplateOutlet]="contentTemplate"
                        [ngTemplateOutletContext]="{
                            item: item
                        }"
                    >
                    </ng-template>
                </li>
            }
            <ng-content select="[markup]"></ng-content>
        </div>
    `,
    standalone: false
})
export class CardDropdownComponent {
    @Input()
    title: string;
    @Input()
    items: any[];

    @Output()
    readonly itemClicked = new EventEmitter<number>();

    @ContentChild(TemplateRef, { static: false })
    contentTemplate: TemplateRef<any>;

    hovered = false;

    @HostListener('mouseenter')
    mouseenter(): void {
        this.hovered = true;
    }

    @HostListener('mouseleave')
    mouseleave(): void {
        this.hovered = false;
    }

    onItemClicked(index: number): void {
        this.hovered = false;
        this.itemClicked.emit(index);
    }
}
